import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from './Icon';
import { getNavItems } from '../utils/navItems';

export default function CommandPalette({ open, onClose, user }) {
  const [query, setQuery] = useState('');
  const [active, setActive] = useState(0);
  const inputRef = useRef(null);
  const navigate = useNavigate();

  const items = useMemo(() => {
    const base = getNavItems(user).map((it) => ({ ...it, group: 'Navigate' }));
    const actions = [
      { to: null, icon: 'settings', label: 'Toggle Theme', group: 'Actions', action: 'theme' }
    ];
    return [...base, ...actions];
  }, [user]);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return items;
    return items.filter((it) => it.label.toLowerCase().includes(q));
  }, [query, items]);

  useEffect(() => {
    if (open) {
      setQuery('');
      setActive(0);
      setTimeout(() => inputRef.current?.focus(), 30);
    }
  }, [open]);

  useEffect(() => { setActive(0); }, [query]);

  if (!open) return null;

  const choose = (it) => {
    if (it.action === 'theme') {
      import('../utils/theme').then((m) => m.toggleTheme());
    } else if (it.to) {
      navigate(it.to);
    }
    onClose();
  };

  const onKeyDown = (e) => {
    if (e.key === 'ArrowDown') { e.preventDefault(); setActive((a) => Math.min(a + 1, filtered.length - 1)); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive((a) => Math.max(a - 1, 0)); }
    else if (e.key === 'Enter') { e.preventDefault(); if (filtered[active]) choose(filtered[active]); }
    else if (e.key === 'Escape') { e.preventDefault(); onClose(); }
  };

  return (
    <div className="command-palette-overlay" onMouseDown={onClose}>
      <div className="command-palette" onMouseDown={(e) => e.stopPropagation()} onKeyDown={onKeyDown}>
        <div className="command-input-wrap">
          <Icon name="search" />
          <input
            ref={inputRef}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search pages and actions…"
            aria-label="Command palette search"
          />
          <Icon name="close" />
        </div>
        <div className="command-list">
          {filtered.length === 0 && <div className="command-empty">No results for “{query}”</div>}
          {filtered.map((it, i) => (
            <div
              key={it.to || it.label}
              className={`command-item ${i === active ? 'active' : ''}`}
              onMouseEnter={() => setActive(i)}
              onClick={() => choose(it)}
            >
              <span className="ci-icon"><Icon name={it.icon} /></span>
              <span className="ci-label">{it.label}</span>
              <span className="ci-sub">{it.group}</span>
            </div>
          ))}
        </div>
        <div className="command-footer">
          <span><kbd>↑</kbd> <kbd>↓</kbd> navigate</span>
          <span><kbd>↵</kbd> select</span>
          <span><kbd>esc</kbd> close</span>
          <span style={{ marginLeft: 'auto' }}><kbd>⌘</kbd><kbd>K</kbd></span>
        </div>
      </div>
    </div>
  );
}
